import React from 'react';

import { Dialog, DialogContent, DialogActions } from '@mui/material';
import { Button, DialogTitle } from '@mui/material';

class ErrorDialog extends React.Component {

    render() {
        return (
            <div>
                <Dialog keepMounted open={this.props.open}
                    onClose={this.props.handleClose}
                    disablePortal
                    disableEnforceFocus
                    sx={{position:'absolute'}}
                >
                    <DialogTitle>
                        Ooops...
                    </DialogTitle>
                    <DialogContent>
                        {this.props.message}
                    </DialogContent>
                    <DialogActions style={{padding:"10px 20px 10px 10px"}}>
                        <Button
                            onClick={() => this.props.handleClose()}
                            color="primary">
                            Ok
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

export default ErrorDialog;
